/**
 * Skeleton loader para formularios de presupuesto.
 * Evita layout shift manteniendo altura fija mientras el formulario real renderiza.
 */

export function FormSkeleton() {
  const shimmer = "animate-pulse bg-slate-200 rounded-lg";

  return (
    <div className="flex flex-col gap-5" aria-hidden="true">
      {/* Título */}
      <div className="space-y-2 mb-2">
        <div className={`${shimmer} h-8 w-3/4`} />
        <div className={`${shimmer} h-4 w-1/2`} />
      </div>

      {/* Nombre */}
      <div className="space-y-1.5">
        <div className={`${shimmer} h-4 w-24`} />
        <div className={`${shimmer} h-12 w-full`} />
      </div>

      {/* Teléfono */}
      <div className="space-y-1.5">
        <div className={`${shimmer} h-4 w-24`} />
        <div className={`${shimmer} h-12 w-full`} />
      </div>

      {/* Fila 2 campos */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div className="space-y-1.5">
          <div className={`${shimmer} h-4 w-20`} />
          <div className={`${shimmer} h-12 w-full`} />
        </div>
        <div className="space-y-1.5">
          <div className={`${shimmer} h-4 w-20`} />
          <div className={`${shimmer} h-12 w-full`} />
        </div>
      </div>

      {/* Select */}
      <div className="space-y-1.5">
        <div className={`${shimmer} h-4 w-32`} />
        <div className={`${shimmer} h-12 w-full`} />
      </div>

      {/* Textarea */}
      <div className="space-y-1.5">
        <div className={`${shimmer} h-4 w-28`} />
        <div className={`${shimmer} h-24 w-full`} />
      </div>

      {/* Checkbox */}
      <div className="flex items-start gap-2.5">
        <div className={`${shimmer} h-5 w-5 mt-1 shrink-0 rounded`} />
        <div className="flex-1 space-y-2">
          <div className={`${shimmer} h-4 w-full`} />
          <div className={`${shimmer} h-3 w-5/6`} />
        </div>
      </div>

      {/* Botón */}
      <div className={`${shimmer} h-14 w-full rounded-full`} />

      {/* Disclaimer */}
      <div className="flex justify-center gap-4">
        <div className={`${shimmer} h-3 w-24`} />
        <div className={`${shimmer} h-3 w-32`} />
      </div>
    </div>
  );
}

export default FormSkeleton;